import { NOTIFICATION_SEND_TO_USER } from '../actionType';

export const notificationAction = (message) => ({
    type: NOTIFICATION_SEND_TO_USER,
    message,
});
